export const TEST_IDS = {
  button: 'playPauseButton',
  icon: 'playPauseIcon',
};
